export const devices = {
  tablet: `screen and (min-width: 769px)`,
  desktop: `screen and (min-width: 1025px)`,
  large: `screen and (min-width: 1201px)`,
  extraLarge: `screen and (min-width: 1600px)`
};